import axios from "axios";

export const deletePromoStoreItem = async (promoStoreId, itemId) => {
  const response = await axios.delete(
    `${process.env.REACT_APP_NODEJS_SERVER_URL}/promostores/${promoStoreId}/items/${itemId}`,
    { headers: { accessToken: localStorage.getItem("accessToken") } },
  );
  if (!response.data?.success) {
    throw new Error(response.data?.message || "Failed to delete PromoStore product.");
  }
  return response.data;
};
